export default __webpack_public_path__ + "static/media/referral-gift-card.862061d5.png";